import styled from '@emotion/styled'

export const Container = styled.div``

export const WrapperHeader = styled.div`
  display: flex;
  /* flex-direction: row; */
  align-items: center;
  justify-content: space-between;
  /* flex-wrap: wrap; */
`

export const WrapperFlex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`
